<div class="navbar navbar-vertical fixed-start navbar-expand-md navbar-light" id="sidebar">

    <ul class="list-inline w-100">
        <li routerLinkActive="active-link">
            <a routerLink="/dashboard" matRipple>
                <small class="icon"><img src="assets/images/dashboard.svg" alt=""></small> Dashboard
            </a>
        </li>
        <!-- 
        <li routerLinkActive="active-link">
            <a href="javascript:void(0)" matRipple>
                <small class="icon"><img src="assets/images/files.svg" alt=""></small> All Files
            </a>
        </li> -->
        <li routerLinkActive="active-link"><a routerLink="/recent-activity" matRipple><small class="icon"><img
                        src="assets/images/recent-activity.svg" alt=""></small> Recent
                Activity</a></li>
        <li routerLinkActive="active-link"><a href="javascript:void(0)" matRipple routerLink="/my-files"><small
                    class="icon"><img src="assets/images/my-files.svg" alt=""></small> My
                Files</a></li>
        <li routerLinkActive="active-link"><a routerLink="/favorites" matRipple><small class="icon"><img
                        src="assets/images/faborites.svg" alt=""></small>
                Favorites</a></li>
        <li routerLinkActive="active-link"><a href="javascript:void(0)" matRipple routerLink="/tags"><small
                    class="icon"><img src="assets/images/tags.svg" alt=""></small> Tags</a>
        </li>
        <li routerLinkActive="active-link"><a routerLink="/trash" matRipple><small class="icon"><img
                        src="assets/images/trash.svg" alt=""></small>
                Trash</a></li>
        <li class="drop-menu">
            <a href="javascript:void(0)" class="droptitle" matRipple>
                <span class="intext">
                    <small class="icon"><img src="assets/images/masters.svg" alt=""></small> Masters
                </span>
            </a>
            <ul class="dropdown-box list-inline">
                <li *ngIf="this.userInfo?.isAdmin"><a routerLink="/masters/groups" matRipple routerLinkActive="active-link">Groups</a></li>
                <li><a routerLink="/masters/categories" matRipple routerLinkActive="active-link">Categories</a></li>
                <li><a routerLink="/masters/sub-categories" routerLinkActive="active-link" matRipple>Sub-Categories</a>
                </li>
                <li *ngIf="this.userInfo?.isAdmin"><a routerLink="/masters/file-type" routerLinkActive="active-link" matRipple>File Types</a></li>
            </ul>
        </li>
        <!-- <li routerLinkActive="active-link"><a href="javascript:void(0)" matRipple><small class="icon"><img
                        src="assets/images/users.svg" alt=""></small>
                Users</a></li> -->
    </ul>


    <!-- <button mat-button><small class="icon"><img src="assets/images/dashboard.svg" alt=""></small> Dashboard</button>
    <button mat-button><small class="icon"><img src="assets/images/files.svg" alt=""></small> All Files</button>
    <button mat-button><small class="icon"><img src="assets/images/recent-activity.svg" alt=""></small> Recent Activity</button>
    <button mat-button><small class="icon"><img src="assets/images/my-files.svg" alt=""></small> My Files</button>
    <button mat-button><small class="icon"><img src="assets/images/faborites.svg" alt=""></small> Favorites</button>
    <button mat-button><small class="icon"><img src="assets/images/tags.svg" alt=""></small> Tags</button>
    <button mat-button><small class="icon"><img src="assets/images/trash.svg" alt=""></small> Trash</button>
    <button mat-button><small class="icon"><img src="assets/images/masters.svg" alt=""></small> Masters</button>
    <button mat-button><small class="icon"><img src="assets/images/users.svg" alt=""></small> Users</button> -->
</div>